import { render, staticRenderFns } from "./TestiMonials.vue?vue&type=template&id=617aca94&"
import script from "./TestiMonials.vue?vue&type=script&lang=js&"
export * from "./TestiMonials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports